import * as Firebase from 'firebase'
import 'firebase/performance'

const config = {
  apiKey: 'AIzaSyAv8cDyg2Kosv-X_UoB5ZQdBLv3BIfN5I0',
  authDomain: 'tyngreninja.firebaseapp.com',
  databaseURL: 'https://tyngreninja.firebaseio.com',
  projectId: 'tyngreninja',
  storageBucket: 'tyngreninja.appspot.com',
  messagingSenderId: '358545013378',
  appId: '1:358545013378:web:e52f68a853c68ded1fd29b',
  measurementId: 'G-J3NJSD2RPY'
}

export default Firebase.initializeApp(config)
